import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { SINGLE_SERIES_COLOR, sharedAxisProps, sharedTooltipProps } from "./chartTheme";
import { formatNumber, formatPercent } from "./formatters";

// One measure, so one hue and no legend — the title already names what is plotted.
// Horizontal bars because channel names ("Organic Search", "Direct") are long enough
// that vertical bars would force rotated, unreadable tick labels.
const ChannelsChart = ({ channels = [] }) => {
  if (!channels.length) {
    return (
      <div className="bg-surface-container-low rounded-2xl p-10 border border-surface-container-high text-center text-on-surface-variant text-sm">
        No channel data in this period.
      </div>
    );
  }

  const renderTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const row = payload[0].payload;
    return (
      <div className="bg-surface-container-lowest border border-outline-variant rounded-xl px-3 py-2 text-xs shadow-lg">
        <p className="font-semibold text-on-surface mb-1">{row.channel}</p>
        <p className="text-on-surface-variant">{formatNumber(row.sessions)} sessions</p>
        <p className="text-on-surface-variant">{formatNumber(row.users)} users</p>
        <p className="text-on-surface-variant">{formatNumber(row.conversions)} conversions</p>
        <p className="text-on-surface-variant">{formatPercent(row.bounce_rate)} bounce rate</p>
      </div>
    );
  };

  return (
    <div className="bg-surface-container-low rounded-2xl p-6 border border-surface-container-high">
      <h3 className="font-headline text-base font-bold mb-4">Sessions by Channel</h3>
      <ResponsiveContainer width="100%" height={Math.max(220, channels.length * 40)}>
        <BarChart
          data={channels}
          layout="vertical"
          margin={{ top: 0, right: 24, left: 0, bottom: 0 }}
          barCategoryGap="24%"
        >
          <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="rgba(19,27,46,0.08)" />
          <XAxis type="number" tickFormatter={formatNumber} {...sharedAxisProps} />
          <YAxis type="category" dataKey="channel" width={140} {...sharedAxisProps} />
          <Tooltip
            {...sharedTooltipProps}
            content={renderTooltip}
            cursor={{ fill: "rgba(46,91,255,0.06)" }}
          />
          <Bar
            dataKey="sessions"
            fill={SINGLE_SERIES_COLOR}
            radius={[0, 4, 4, 0]}
            maxBarSize={18}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChannelsChart;
